import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

function transformObjectKeys (_char, subject) {
  return Object.keys(subject).reduce(function (acc, cur) {
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, cur.replaceAll(_char, ''), subject[cur]));
  }, {});
}

export default transformObjectKeys;
//# sourceMappingURL=transform-object-keys.esm.js.map
